<template>
  <v-container fluid class="invoice-page pa-4">
    <router-view />
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import invoiceStore from "./store.js";

export default {
  name: "invoice",

  mixins: [RegisterStoreModule],

  created() {
    this.registerStoreModule("invoice", invoiceStore);
    document.title = "smplsale - Invoice";
  },

  methods: {
    ...mapActions("invoice", ["ResetInvoice"]),
  },
};
</script>

<style scoped>
.invoice-page {
  background: #f8fafc;
  min-height: 100%;
}

@media (max-width: 600px) {
  .invoice-page {
    padding: 10px !important;
  }
}
</style>